import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ITagIcon, ItemComponent, LinkComponent, ListDetailComponent } from '@tecalisdev/infinity';
import {
	BOOLEAN_STATUS,
	IOperationOcrDetail,
	IOperationPolDetail,
	IProcessDetailResponse,
} from '../../../../../processes/models/processes.models';
import { ModalDataComparisonComponent } from './modal-data-comparison/modal-data-comparison.component';

@Component({
	selector: 'app-item-check-facial-recognition',
	imports: [TranslatePipe, ItemComponent, ListDetailComponent, LinkComponent, ModalDataComparisonComponent],
	templateUrl: './item-check-facial-recognition.component.html',
	styleUrl: './item-check-facial-recognition.component.scss',
})
export class ItemCheckFacialRecognitionComponent implements OnInit {
	@Input() detail: IProcessDetailResponse['data']['POL'] | IOperationPolDetail;
	@Input() birthdate?: string;
	@Input() polImages?: IOperationPolDetail['images'];
	@Input() ocrImages?: IOperationOcrDetail['images'];

	public tagIcon?: ITagIcon;
	public showDataComparison = false;

	ngOnInit(): void {
		this.tagIcon = this.getTagIconItem(this.detail?.antifraud?.FACIAL_RECOGNITION);
	}

	public getTagIconItem(status: BOOLEAN_STATUS | string): ITagIcon {
		return status === 'OK'
			? { icon: 'icon-check', status: 'success', size: 'sm' }
			: { icon: 'icon-alert', status: 'error', size: 'sm' };
	}

	public seeDetails(): void {
		this.showDataComparison = true;
	}

	public closeModalDataComparison(): void {
		this.showDataComparison = false;
	}
}
